import styled from "styled-components";

const ButtonIcon = styled.button`
  background: none;
  border: none;
  padding: 0.6rem;
  border-radius: 50%;
  transition: all 0.2s;

  &:hover {
    background-color: #f9f9f9;
  }

  & svg {
    width: 2.2rem;
    height: 2.2rem;
    color: #f9f9f9;
  }
`;

export default ButtonIcon;
